import classnames from "classnames";

import "./swiperNavButton.scss";

type SwiperNavButtonProps = {
    icon: string;
    disabled: boolean;
    onClick?: any;
    className?: any;
    innerRef?: any;
};

const SwiperNavButton = ({
    icon,
    disabled,
    onClick,
    className,
    innerRef
}: SwiperNavButtonProps) => (
    <div
        className={classnames(
            "swiper-nav-button",
            disabled && "swiper-nav-button--disabled",
            className
        )}
        ref={innerRef}
        onClick={() => onClick?.()}
    >
        <i className={`las la-angle-${icon}`} />
    </div>
);

export { SwiperNavButton };
